const statuses = [
    "Request Submitted",
    "Accredited Installer Assigned",
    "En Route to Job",
    "Installer On Site",
    "DStv Activated"
];

type InstallationStatusProps = {
    status: number
}

const InstallationProgressBar = (props: InstallationStatusProps) => {
    const { status } = props;

    const css = `installation-progress-wrapper status-${status}`;

    return (
        <div className={css}>
            <div className="installation-progress">
                <div className="installation-progress-bar"></div>
                <div className="installation-progress-done"></div>
                <div className="installation-progress-indicator">
                    <i className="icon icon-tracking"></i>
                </div>
            </div>

            <ol className="status">
                {statuses.map((x, ix) => <li key={ix}>{x}</li>)}
            </ol>
        </div>
    );
}

export default InstallationProgressBar;